import Immutable from 'seamless-immutable';
import {
  FETCH_SPONSORS_LIST_START,
  FETCH_SPONSORS_LIST_SUCCESS,
  FETCH_SPONSORS_LIST_ERROR
} from '../Actions/SponsorsList';

const initialState = Immutable({
  list: [],
  fetching: false,
  success: false,
  error: null
});

export default function sponsorsListReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SPONSORS_LIST_START:
      return Immutable.merge(state, {
        list: [],
        fetching: true,
        success: false,
        error: null
      });
    case FETCH_SPONSORS_LIST_SUCCESS:
      return Immutable.merge(state, {
        list: action.payload.list,
        fetching: false,
        success: true,
        error: null
      });
    case FETCH_SPONSORS_LIST_ERROR:
      return Immutable.merge(state, {
        list: [],
        fetching: false,
        success: false,
        error: action.payload.error
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/SponsorsListReducer.js